import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type AssignCourseResponse = {
    studentId:string;
    courseId:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;
export const AcceptStudentRequest = ({
    requestId
}: {
    requestId: string;
}): Promise<AssignCourseResponse> => {
  return axios.patch(`/course/requests/accept/${requestId}`);
};
